<template>
    <el-card class="mini-box-card  box-d-card" >
        <template class="mini-card-header" #header>
            <span>Quotation Pricing</span>

        </template>
        <el-descriptions
            size="small"
            direction="vertical"
            :column="10"
            border
        >
            <el-descriptions-item label="Quote Price">{{ Intl.NumberFormat('en-US').format(enquiry.finalquotation.quote_price)}} <small>{{enquiry.finalquotation.pricetypetext}}</small></el-descriptions-item>
            <el-descriptions-item label="Hotel Cost" v-if="enquiry.finalquotation.hotel_cost>0"> {{ Intl.NumberFormat('en-US').format(enquiry.finalquotation.hotel_cost) }}</el-descriptions-item>
            <el-descriptions-item label="Flight Cost" v-if="enquiry.finalquotation.flight_cost>0">{{ Intl.NumberFormat('en-US').format(enquiry.finalquotation.flight_cost) }}</el-descriptions-item>
            <el-descriptions-item label="Visa Cost" v-if="enquiry.finalquotation.visa_cost>0">{{ Intl.NumberFormat('en-US').format(enquiry.finalquotation.visa_cost) }}</el-descriptions-item>
            <el-descriptions-item label="Land Cost" v-if="enquiry.finalquotation.land_cost>0">{{ Intl.NumberFormat('en-US').format(enquiry.finalquotation.land_cost) }}</el-descriptions-item>
            <el-descriptions-item label="Cruise Cost" v-if="enquiry.finalquotation.cruise_cost>0">{{ Intl.NumberFormat('en-US').format(enquiry.finalquotation.cruise_cost) }}</el-descriptions-item>
            <el-descriptions-item label="Travel Insurance" v-if="enquiry.finalquotation.travel_insurance_cost>0">{{ Intl.NumberFormat('en-US').format(enquiry.finalquotation.travel_insurance_cost) }}</el-descriptions-item>
            <el-descriptions-item label="TCS" v-if="enquiry.finalquotation.tds_cost>0">{{ Intl.NumberFormat('en-US').format(enquiry.finalquotation.tds_cost) }}</el-descriptions-item>
            <el-descriptions-item label="GST" v-if="!enquiry.finalquotation.non_flight_gst && !enquiry.finalquotation.flight_gst && !enquiry.finalquotation.pricingdetails">{{ Intl.NumberFormat('en-US').format(enquiry.finalquotation.gst) }}</el-descriptions-item>
            <el-descriptions-item label="GST (Non-Flight)" v-if="(enquiry.finalquotation.pricingdetails?.gst?.total > 0) || (enquiry.finalquotation.non_flight_gst > 0)">{{ Intl.NumberFormat('en-US').format(enquiry.finalquotation.pricingdetails?.gst?.total || enquiry.finalquotation.non_flight_gst) }}</el-descriptions-item>
            <el-descriptions-item label="GST (Flight)" v-if="(enquiry.finalquotation.pricingdetails?.flightgst?.total > 0) || (enquiry.finalquotation.flight_gst > 0)">{{ Intl.NumberFormat('en-US').format(enquiry.finalquotation.pricingdetails?.flightgst?.total || enquiry.finalquotation.flight_gst) }}</el-descriptions-item>
            <el-descriptions-item label="Profit">{{ Intl.NumberFormat('en-US').format(enquiry.finalquotation.profit) }}</el-descriptions-item>

        </el-descriptions>
    </el-card>


</template>

<script>
import {
    ElCheckbox,ElCheckboxGroup,ElDatePicker,ElSelectV2,ElInputNumber,ElRadioGroup,ElRadio,ElDescriptionsItem,ElDescriptions,ElCard,ElTag,ElRow,ElCol,ElButton,ElDrawer,ElForm,ElFormItem,ElInput,ElSelect,ElOption
} from 'element-plus'
import { Edit } from '@element-plus/icons-vue'
import moment from "moment";
export default {
    name: "QuotationPricingDetails",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        }
    },
    emits: ["saved"],
    components: { ElCheckbox,ElCheckboxGroup,ElDatePicker,ElSelectV2,ElInputNumber,ElRadioGroup,ElRadio,ElDescriptionsItem,ElDescriptions,ElSelect,ElOption,ElCard,ElTag,ElRow,ElCol,ElButton,Edit,ElDrawer,ElForm,ElFormItem,ElInput },
    data() {
        return {

        }
    },
    created(){

    },
    methods:{

    }
}
</script>

<style scoped>

</style>
